export default {
  methods: {
    onlyNumberInRange (e, max = Number.MAX_SAFE_INTEGER, min = 0) {
      if (!(/\d/.test(e.key) || e.key === 'Enter')) {
        return e.preventDefault()
      }
      const input = Number(e.target.value + (e.key === 'Enter' ? '' : e.key))
      if (input > max) {
        return e.preventDefault()
      }
      if (input < min) {
        return e.preventDefault()
      }
      // 0始まり対策
      if (String(e.target.value + (e.key === 'Enter' ? '' : e.key)).length > String(max).length) {
        return e.preventDefault()
      }
    }
  }
}
